import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.AuditLog.List.IRequest;
type Response = Api.Core.AuditLog.List.IResponse;
type Headers = Api.Core.AuditLog.List.IHeaders;
const url = '/api/Management/AuditLog';
export default async function auditLogListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
